import { SB } from '@play-co/replicant';

export const magicLampsSchema = {
  magicLamps: SB.object({
    // Event id of the magic lamps minigame that user is participating
    eventId: SB.string(),
    // Last tim euse has seen the popup for the magic lamps minigame
    lastViewedAt: SB.int(),
    // Time when user started playing the magic lamps minigame
    firstPlayedAt: SB.int(),
    // Time when user last played the magic lamps minigame
    lastPlayedAt: SB.int(),
    // Number of times user has played the magic lamps minigame
    numPlays: SB.int(),
    // Current round of the magic lamps minigame
    round: SB.int(),
    // Number of continues used
    continuesUsed: SB.int(),
    // Rewards accumulated from the magic lamps minigame
    rewards: SB.map(SB.int()),
    // Check if user has purchased continue for the current round
    continuing: SB.boolean().optional(),
    // Whether the user has fallen into a trap
    trap: SB.boolean(),
    // Wether the user has an active session
    playing: SB.boolean(),
  }).optional(),
};
